@use '~/assets/css/media/media.scss' as *;
@use '~/assets/css/colors/colors.scss' as *;

.handlers {
    .workspace-container {
        padding-top: 40px;
        padding-right: 16px;
        padding-left: 16px;

        @media (--extra-large) {
            padding-right: 0;
            padding-left: 0;
        }
    }

    &__hero {
        max-width: 820px;
        margin: 0 auto;
        text-align: center;
    }

    &__title {
        margin: 0;
        color: #11192b;
        font-size: 34px;
        font-weight: 700;
        line-height: 1.2;
    }

    &__subtitle {
        max-width: 660px;
        margin: 12px auto 0;
        color: #11192b99;
        font-size: 16px;
        line-height: 1.5;
    }

    &__back {
        display: inline-flex;
        align-items: center;
        width: fit-content;
        margin-bottom: 10px;
        color: $color-blue-button;
        font-size: 16px;
        font-weight: 500;

        &:hover,
        &:focus-visible {
            text-decoration: underline;
        }
    }

    &__finder {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 14px;
        max-width: 960px;
        margin: 24px auto 0;
        padding: 18px 20px;
        border: 1px solid rgb(11 61 148 / 10%);
        border-radius: 16px;
        background: $color-white;
        box-shadow: 0 12px 34px rgb(17 25 43 / 5%);

        @media (--medium) {
            grid-template-columns: 220px minmax(0, 1fr);
            align-items: center;
            gap: 24px;
            padding: 20px 24px;
        }
    }

    &__finder-copy {
        h2 {
            margin: 0;
            color: #11192b;
            font-size: 18px;
            line-height: 1.3;
        }

    }

    &__search {
        min-width: 0;
        color: #11192b66;

        .control-form-field,
        .control-form {
            width: 100%;
        }

        .control-form__input {
            width: 100%;
            height: 42px;
            min-height: 42px;
            padding-right: 72px;
            padding-left: 40px;
            border: 1px solid rgb(11 61 148 / 24%);
            border-radius: 8px;
            font-size: 14px;

            &:focus {
                border-color: $color-blue-button;
                box-shadow: 0 0 0 3px rgb(11 61 148 / 10%);
            }
        }

        .control-form__icon-left {
            left: 13px;

            svg {
                width: 18px;
                height: 18px;
            }
        }

        .control-form__loading-indicator {
            right: 40px;
        }

        .control-form__loading-indicator-icon {
            width: 18px;
            height: 18px;
        }
    }

    &__search-controls {
        position: relative;
    }

    &__search-clear {
        display: inline-flex;
        position: absolute;
        z-index: 20;
        top: 50%;
        right: 7px;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        padding: 0;
        transform: translateY(-50%);
        border: 0;
        border-radius: 6px;
        background: transparent;
        color: #11192b99;
        font-size: 20px;
        font-weight: 400;
        line-height: 1;
        cursor: pointer;

        &:hover,
        &:focus-visible {
            background: #f1f6ff;
            color: $color-blue-button;
        }
    }

    &__search-status {
        min-height: 16px;
        margin: 5px 0 0 10px;
        color: #11192b99;
        font-size: 11px;
        line-height: 1.4;

        &_error {
            color: #b42318;
        }
    }

    &__view-switch {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: 100%;
        max-width: 320px;
        margin: 24px auto 0;
        padding: 3px;
        border: 1px solid rgb(11 61 148 / 12%);
        border-radius: 10px;
        background: rgb(11 61 148 / 7%);

        &-button {
            min-height: 38px;
            padding: 7px 16px;
            border: 0;
            border-radius: 7px;
            background: transparent;
            color: $color-blue-button;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

            &:focus-visible {
                outline: 2px solid rgb(11 61 148 / 35%);
                outline-offset: 1px;
            }
        }

        .handlers__view-switch-button_active {
            background: $color-blue-button;
            box-shadow: 0 3px 8px rgb(11 61 148 / 18%);
            color: $color-white;
        }
    }

    &__countries-panel {
        margin-top: 30px;

        &[hidden] {
            display: none;
        }
    }

    &__countries {
        margin-top: 0;
        border: 1px solid rgb(11 61 148 / 10%);
        border-radius: 16px;
        background: $color-white;
        overflow: hidden;
    }

    &__countries-content {
        padding: 24px;
    }

    &__alphabet {
        position: sticky;
        top: 8px;
        z-index: 2;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        padding: 10px;
        border: 1px solid rgb(11 61 148 / 10%);
        border-radius: 12px;
        background: rgb(255 255 255 / 96%);
        box-shadow: 0 6px 18px rgb(17 25 43 / 6%);

        &-link {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 8px;
            color: $color-blue-button;
            font-size: 13px;
            font-weight: 700;

            &:hover,
            &:focus-visible {
                background: $color-blue-button;
                color: $color-white;
                text-decoration: none;
            }
        }
    }

    &__country-groups {
        margin-top: 10px;
    }

    &__country-group {
        display: grid;
        grid-template-columns: 44px minmax(0, 1fr);
        gap: 14px;
        padding: 22px 0;
        border-bottom: 1px solid rgb(17 25 43 / 8%);
        scroll-margin-top: 62px;

        &:last-child {
            padding-bottom: 0;
            border-bottom: 0;
        }

        h3 {
            margin: 3px 0 0;
            color: $color-blue-button;
            font-size: 24px;
            line-height: 1;
        }
    }

    &__country-grid {
        display: grid;
        grid-template-columns: repeat(1, minmax(0, 1fr));
        gap: 6px 18px;
        margin: 0;
        padding: 0;
        list-style: none;

        @media (--small) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        @media (--large) {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        .handlers__country-link {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            min-height: 42px;
            padding: 8px 10px;
            border-radius: 8px;
            color: $color-blue-button;
            font-size: 13px;
            font-weight: 600;

            &:hover,
            &:focus-visible {
                background: #f4f8ff;
                text-decoration: none;
            }

            small {
                flex: 0 0 auto;
                color: #11192b80;
                font-size: 11px;
                font-weight: 500;
            }
        }
    }

    &__results {
        margin-top: 30px;

        &[hidden] {
            display: none;
        }
    }

    &__results-heading {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 24px;
        margin-bottom: 14px;

        h2 {
            margin: 0;
            color: #11192b;
            font-size: 22px;
        }

        p {
            margin: 6px 0 0;
            color: #11192b99;
            font-size: 13px;
        }
    }

    &__results-page {
        flex: 0 0 auto;
        color: #11192b99;
        font-size: 13px;
        font-weight: 600;
    }

    &__list,
    &__loading {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 10px;

        @media (--medium) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    &__item-arrow {
        color: $color-blue-button;
        font-size: 18px;
        transition: transform 0.15s ease;
    }

    &__item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 18px;
        min-width: 0;
        min-height: 82px;
        padding: 15px 18px;
        border: 1px solid rgb(11 61 148 / 11%);
        border-radius: 12px;
        background: $color-white;
        color: inherit;
        text-decoration: none;
        transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

        &:hover,
        &:focus-visible {
            border-color: rgb(11 61 148 / 40%);
            box-shadow: 0 8px 22px rgb(17 25 43 / 7%);
            text-decoration: none;
            transform: translateY(-1px);
            outline: none;

            .handlers__item-arrow {
                transform: translateX(3px);
            }
        }
    }

    &__item-main {
        display: flex;
        min-width: 0;
        flex-direction: column;
        gap: 5px;
    }

    &__item-title {
        overflow: hidden;
        color: #11192b;
        font-size: 15px;
        font-weight: 700;
        line-height: 1.3;
        text-overflow: ellipsis;
    }

    &__item-text {
        overflow: hidden;
        color: #11192b99;
        font-size: 12px;
        line-height: 1.35;
        text-overflow: ellipsis;
    }

    &__item-side {
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        gap: 12px;
    }

    &__item-codes {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 5px;

        span {
            display: inline-flex;
            align-items: center;
            min-height: 26px;
            padding: 4px 7px;
            border-radius: 6px;
            background: rgb(11 61 148 / 7%);
            color: $color-blue-button;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.03em;
        }
    }

    &__loading-item {
        min-height: 82px;
        border-radius: 12px;
        background: linear-gradient(90deg, #ffffff 20%, #f5f7fb 50%, #ffffff 80%);
        background-size: 220% 100%;
        animation: handlers-loading 1.2s ease-in-out infinite;
    }

    &__empty {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 8px;
        padding: 46px 24px;
        border: 1px solid rgb(11 61 148 / 10%);
        border-radius: 14px;
        background: $color-white;
        color: #11192b99;
        text-align: center;

        strong {
            color: #11192b;
            font-size: 16px;
        }

        span {
            font-size: 13px;
        }

        button {
            margin-top: 8px;
            padding: 9px 14px;
            border: 0;
            border-radius: 8px;
            background: $color-blue-button;
            color: $color-white;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
        }

        &_error {
            border-color: rgb(180 35 24 / 15%);
        }
    }

    &__pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin: 28px 0 44px;
    }

    &__pagination-pages {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 6px;
    }

    &__pagination-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 36px;
        min-height: 36px;
        padding: 6px 10px;
        border: 1px solid rgb(11 61 148 / 20%);
        border-radius: 8px;
        background: $color-white;
        color: $color-blue-button;
        font-size: 13px;
        font-weight: 700;
        text-decoration: none;

        &:hover,
        &:focus-visible,
        &_active {
            border-color: $color-blue-button;
            background: $color-blue-button;
            color: $color-white;
        }

        &_direction {
            min-width: 86px;
        }
    }

    &__pagination-ellipsis {
        align-self: center;
        min-width: 18px;
        color: #11192b99;
        text-align: center;
    }

    @media (width <= 767px) {
        .workspace-container {
            padding-top: 28px;
        }

        &__title {
            font-size: 28px;
        }

        &__subtitle {
            margin-top: 9px;
            font-size: 14px;
        }

        &__finder {
            margin-top: 18px;
            padding: 16px;
        }

        &__countries-content {
            padding: 16px;
        }

        &__alphabet {
            top: 4px;

            a {
                width: 30px;
                height: 30px;
            }
        }

        &__country-group {
            grid-template-columns: 32px minmax(0, 1fr);
            gap: 8px;
        }

        &__results {
            margin-top: 24px;
        }

        &__countries-panel {
            margin-top: 24px;
        }

        &__results-heading {
            align-items: flex-start;
            flex-direction: column;
            gap: 7px;
        }

        &__item {
            min-height: 88px;
            padding: 14px;
        }

        &__item-side {
            gap: 8px;
        }

        &__item-codes {
            max-width: 82px;
        }

        &__pagination {
            align-items: stretch;
            flex-direction: column;
        }

        &__pagination-link_direction {
            align-self: center;
        }
    }
}

@keyframes handlers-loading {
    from {
        background-position: 100% 0;
    }

    to {
        background-position: -100% 0;
    }
}

@media (prefers-reduced-motion: reduce) {
    .handlers__item,
    .handlers__item-arrow,
    .handlers__view-switch-button,
    .handlers__loading-item {
        transition: none;
        animation: none;
    }
}
